module.exports = __webpack_public_path__ + "static/commerce2x-logo-3169bc6a7f3fc7a083737d0202113cf6.png";